import { industryTranslations } from "../industry-translations";

export const agencyCandidates = {
  candidateSearch: {
    banner: {
      labels: {
        laborType: { vi: "Loại hình lao động", bn: "কর্মসংস্থানের ধরন" },
        industry: { vi: "Ngành nghề", bn: "শিল্প" },
        expectedSalary: { vi: "Mức lương mong muốn", bn: "কাঙ্ক্ষিত বেতন" }
      },
      placeholders: {
        allLaborTypes: { vi: "Tất cả loại hình", bn: "সব ধরনের" },
        allIndustries: { vi: "Tất cả ngành nghề", bn: "সব শিল্প" },
        allSalaries: { vi: "Tất cả mức lương", bn: "সব বেতনের স্তর" },
        salaryUnder: { vi: "Từ {val}$ trở xuống", bn: "{val}$ বা তার কম থেকে" }
      },
      laborTypes: {
        unskilled: { vi: "Lao động phổ thông", bn: "অদক্ষ শ্রম" },
        skilled: { vi: "Lao động kỹ thuật", bn: "দক্ষ শ্রম" },
        engineer: { vi: "Kỹ sư, chuyên gia", bn: "প্রকৌশলী ও বুদ্ধিজীবী" }
      },
      searchButton: { vi: "Tìm kiếm", bn: "অনুসন্ধান করুন" }
    },
    industryNames: {
      ...industryTranslations
    } as Record<string, { vi: string, bn: string } | undefined>,
    industryDetailNames: industryTranslations as Record<string, { vi: string, bn: string } | undefined>,
    filters: {
      titles: {
        candidateFilters: { vi: "Bộ lọc ứng viên", bn: "প্রার্থী ফিল্টার" },
        keywordSearch: { vi: "Tìm kiếm từ khóa", bn: "কীওয়ার্ড অনুসন্ধান" },
        jobInfo: { vi: "Thông tin lao động", bn: "শ্রম তথ্য" },
        industrySkills: { vi: "Ngành nghề & Kỹ năng", bn: "শিল্প ও বিশেষ দক্ষতা" },
        salary: { vi: "Mức lương", bn: "বেতন" },
        gender: { vi: "Giới tính", bn: "লিঙ্গ" },
        english: { vi: "Tiếng Anh", bn: "ইংরেজি" },
        experience: { vi: "Kinh nghiệm làm việc", bn: "কাজের অভিজ্ঞতা" },
        bodyStats: { vi: "Thông số cơ thể", bn: "শারীরিক গঠন" },
        education: { vi: "Trình độ học vấn", bn: "শিক্ষাগত যোগ্যতা" },
        familyStatus: { vi: "Gia đình & Tình trạng", bn: "পরিবার ও বৈবাহিক অবস্থা" },
        health: { vi: "Thể chất & Sức khoẻ", bn: "শারীরিক অবস্থা ও স্বাস্থ্য" },
        vietnamese: { vi: "Trình độ tiếng Việt", bn: "ভিয়েতনামী ভাষা" }
      },
      labels: {
        keywordPlaceholder: { vi: "Tên, kỹ năng, ngành nghề...", bn: "নাম, দক্ষতা, শিল্প..." },
        agency: { vi: "Đối tác", bn: "নিয়োগকারী এজেন্সি" },
        allAgencies: { vi: "Tất cả Đối tác", bn: "সব এজেন্সি" },
        laborType: { vi: "Loại hình lao động mong muốn", bn: "পছন্দসই শ্রমের ধরন" },
        industry: { vi: "Ngành nghề", bn: "শিল্প" },
        allIndustries: { vi: "Tất cả ngành nghề", bn: "সব শিল্প" },
        jobDetail: { vi: "Chi tiết công việc", bn: "কাজের বিস্তারিত" },
        allJobDetails: { vi: "Tất cả công việc", bn: "সব কাজ" },
        salaryVn: { vi: "Lương mong muốn tại Việt Nam", bn: "ভিয়েতনame কাঙ্ক্ষিত বেতন" },
        salaryCurrent: { vi: "Lương hiện tại", bn: "বর্তমান বেতন" },
        englishCert: { vi: "Chứng chỉ", bn: "সার্টিফিকেট" },
        englishComm: { vi: "Khả năng giao tiếp", bn: "যোগাযোগ দক্ষতা" },
        expIndustry: { vi: "Ngành nghề kinh nghiệm", bn: "অভিজ্ঞতার ক্ষেত্র" },
        expDetail: { vi: "Lĩnh vực tay nghề", bn: "দক্ষতার ক্ষেত্র" },
        expYears: { vi: "Số năm kinh nghiệm", bn: "অভিজ্ঞতার বছর" },
        vnCert: { vi: "Chứng chỉ NLTV", bn: "NLTV সার্টিফিকেট" },
        vnComm: { vi: "Giao tiếp tiếng Việt", bn: "ভিয়েতনামী যোগাযোগ" },
        workedAbroad: { vi: "Đã từng đi làm nước ngoài?", bn: "আগে কি বিদেশে কাজ করেছেন?" },
        workedCountry: { vi: "Nước đã làm việc", bn: "কাজের দেশ" },
        age: { vi: "Độ tuổi", bn: "বয়স" },
        height: { vi: "Chiều cao (cm)", bn: "উচ্চতা (সেমি)" },
        weight: { vi: "Cân nặng (kg)", bn: "ওজন (কেজি)" },
        education: { vi: "Bằng cấp", bn: "শিক্ষাগত যোগ্যতা" },
        marital: { vi: "Hôn nhân", bn: "বৈবাহিক অবস্থা" },
        vision: { vi: "Thị lực", bn: "দৃষ্টিশক্তি" },
        tattoo: { vi: "Hình xăm", bn: "ট্যাটু বা উল্কি" },
        smoking: { vi: "Hút thuốc", bn: "ধূমপান" },
        drinking: { vi: "Uống rượu", bn: "মদ্যপান" },
        hobbies: { vi: "Sở thích", bn: "শখ" },
        allergies: { vi: "Dị ứng", bn: "অ্যালার্জি" },
        location: { vi: "Địa điểm", bn: "অবস্থান" },
        searchHobbies: { vi: "Tìm kiếm sở thích...", bn: "শখ খুঁজুন..." },
        searchAllergies: { vi: "Tìm kiếm dị ứng...", bn: "অ্যালার্জি খুঁজুন..." },
        searchLocation: { vi: "Tìm kiếm địa điểm...", bn: "অবস্থান খুঁজুন..." },
        city: { vi: "Tỉnh/Thành phố", bn: "বিভাগ/শহর" },
        video: { vi: "Có đính kèm Video", bn: "ভিডিও সংযুক্ত" },
        selfIntroVideo: { vi: "Video giới thiệu bản thân", bn: "আত্ম-পরিচয় ভিডিও" },
        skillVideo: { vi: "Video tay nghề", bn: "দক্ষতা ভিডিও" },
        photo: { vi: "Có hình ảnh", bn: "ছবি আছে" },
        portraitPhoto: { vi: "Ảnh chân dung", bn: "পোর্ট্রেট ছবি" },
        fullPhoto: { vi: "Ảnh toàn thân", bn: "ফুল ছবি" },
        docs: { vi: "Có đủ hồ sơ/giấy tờ", bn: "সব নথি আছে" },
        passport: { vi: "Hộ chiếu", bn: "পাসপোর্ট" },
        idCard: { vi: "Thẻ ID quốc gia", bn: "ন্যাশনাল আইডি কার্ড" },
        pcc: { vi: "Lý lịch tư pháp", bn: "পুলিশ ক্লিয়ারেন্স" },
        medical: { vi: "Giấy khám sức khoẻ", bn: "মেডিকেল রিপোর্ট" },
        degree: { vi: "Bằng cấp", bn: "ডিগ্রি বা সনদ" },
        mediaPresence: { vi: "Hồ sơ, Hình ảnh, Video", bn: "মিডিয়া উপস্থিতি" },
        all: { vi: "Tất cả", bn: "সব" }
      },
      options: {
        gender: {
          male: { vi: "Nam", bn: "পুরুষ" },
          female: { vi: "Nữ", bn: "নারী" }
        },
        salaryRange: {
          all: { vi: "Tất cả", bn: "সব" },
          from: { vi: "Trên", bn: "উপর" },
          under: { vi: "Dưới", bn: "নীচে" }
        },
        experience: {
          noRequirement: { vi: "Không yêu cầu", bn: "প্রয়োজন নেই" },
          none: { vi: "Không KN", bn: "অভিজ্ঞতা নেই" },
          from: { vi: "Trên", bn: "উপরে" },
          under: { vi: "Dưới", bn: "নিচে" },
          years: { vi: "năm", bn: "বছর" },
          worked: { vi: "Đã từng", bn: "হ্যাঁ" },
          notWorked: { vi: "Chưa từng", bn: "না" }
        },
        marital: {
          single: { vi: "Độc thân", bn: "অবিবাহিত" },
          married: { vi: "Đã kết hôn", bn: "বিবাহিত" }
        },
        tattoo: {
          none: { vi: "Không có", bn: "নেই" },
          small: { vi: "Nhỏ, kín", bn: "ছোট বা ঢাকা" },
          large: { vi: "To, lộ", bn: "বড় বা উন্মুক্ত" }
        },
        smoking: {
          yes: { vi: "Có", bn: "হ্যাঁ" },
          no: { vi: "Không", bn: "না" },
          sometimes: { vi: "Thỉnh thoảng", bn: "মাঝে মাঝে" }
        },
        vision: {
          under5: { vi: "Dưới 5/10", bn: "৫/১০ এর নিচে" },
          nearsighted: { vi: "Cận", bn: "ক্ষীণদৃষ্টি" },
          farsighted: { vi: "Viễn", bn: "দূরদৃষ্টি" },
          astigmatism: { vi: "Loạn", bn: "বিষমদৃষ্টি" }
        },
        languageLevels: {
          none: { vi: "Không có", bn: "নেই" },
          basic: { vi: "Cơ bản", bn: "প্রাথমিক" },
          intermediate: { vi: "Trung bình", bn: "মাঝারি" },
          good: { vi: "Tốt", bn: "ভালো" },
          native: { vi: "Bản ngữ", bn: "মাতৃভাষা" }
        },
        workedCountries: {
          'Nhật Bản': { vi: 'Nhật Bản', bn: 'জাপান' },
          'Hàn Quốc': { vi: 'Hàn Quốc', bn: 'দক্ষিণ কোরিয়া' },
          'Đài Loan': { vi: 'Đài Loan', bn: 'তাইওয়ান' },
          'Singapore': { vi: 'Singapore', bn: 'সিঙ্গাপুর' },
          'Malaysia': { vi: 'Malaysia', bn: 'মালয়েশিয়া' },
          'Trung Đông': { vi: 'Trung Đông', bn: 'মধ্যপ্রাচ্য' }
        },
        years: { vi: "{val} năm", bn: "{val} বছর" }
      },
      buttons: {
        apply: { vi: "Áp dụng", bn: "প্রয়োগ করুন" },
        reset: { vi: "Đặt lại", bn: "রিসেট করুন" },
        resetShort: { vi: "Xóa", bn: "무ছুন" },
        counting: { vi: "Đang đếm...", bn: "গণনা হচ্ছে..." },
        applyWithCount: { vi: "Áp dụng ({count})", bn: "প্রয়োগ করুন ({count})" },
        results: { vi: "Xem {count} ứng viên", bn: "{count} প্রার্থী দেখুন" }
      },
      errors: {
        candidateNotFound: { vi: "Mã ứng viên không tồn tại", bn: "প্রার্থীর আইডি বিদ্যমান নেই" },
        accessError: { vi: "Lỗi truy cập dữ liệu cho ứng viên", bn: "প্রার্থীর জন্য ডেটা অ্যাক্সেস ত্রুটি" },
        backToHub: { vi: "Quay lại Hub", bn: "ড্যাশবোর্ডে ফিরে যান" },
        accessDenied: {
          title: { vi: "Truy cập bị từ chối", bn: "প্রবেশাধিকার অস্বীকার করা হয়েছে" },
          desc: { vi: "Bạn cần có vai trò Đối tác hoặc Đối tác chiến lược - Tổng đại lý để xem hồ sơ ứng viên này.", bn: "এই প্রার্থীর প্রোফাইল দেখার জন্য আপনার পার্টনার বা কৌশলগত অংশীদার - মাস্টার এজেন্টের ভূমিকা থাকা প্রয়োজন।" },
          button: { vi: "Quay lại Dashboard", bn: "ড্যাশবোর্ডে ফিরে যান" }
        }
      },
      common: {
        showMore: { vi: "Xem thêm", bn: "আরো দেখুন" },
        collapse: { vi: "Thu gọn", bn: "সংক্ষিপ্ত করুন" },
        noResults: { vi: "Không tìm thấy kết quả", bn: "কোনো ফলাফল পাওয়া যায়নি" }
      },
      hobbiesAndAllergies: {
        // Hobbies
        'Đọc sách': { vi: 'Đọc sách', bn: 'বই পড়া' },
        'Xem phim': { vi: 'Xem phim', bn: 'সিনেমা দেখা' },
        'Nghe nhạc': { vi: 'Nghe nhạc', bn: 'গান শোনা' },
        'Chơi thể thao': { vi: 'Chơi thể thao', bn: 'খেলাধুলা করা' },
        'Bóng đá': { vi: 'Bóng đá', bn: 'ফুটবল' },
        'Bóng rổ': { vi: 'Bóng rổ', bn: 'বাস্কেটবল' },
        'Cầu lông': { vi: 'Cầu lông', bn: 'ব্যাডমিন্টন' },
        'Bóng chuyền': { vi: 'Bóng chuyền', bn: 'ভলিবল' },
        'Du lịch': { vi: 'Du lịch', bn: 'ভ্রমণ করা' },
        'Nấu ăn': { vi: 'Nấu ăn', bn: 'রান্না করা' },
        'Chơi game': { vi: 'Chơi game', bn: 'গেম খেলা' },
        'Lập trình': { vi: 'Lập trình', bn: 'প্রোগ্রামিং' },
        'Viết lách': { vi: 'Viết lách', bn: 'লেখালেখি' },
        'Chụp ảnh': { vi: 'Chụp ảnh', bn: 'ফটোগ্রাফি' },
        'Vẽ tranh': { vi: 'Vẽ tranh', bn: 'চিত্রাঙ্কন' },
        'Đi bộ': { vi: 'Đi bộ', bn: 'হাঁটা' },
        'Chạy bộ': { vi: 'Chạy bộ', bn: 'দৌড়ানো' },
        'Leo núi': { vi: 'Leo núi', bn: 'পাহাড়ে চড়া (ট্র্যাকিং)' },
        'Bơi lội': { vi: 'Bơi lội', bn: 'সাঁতার' },
        'Cắm trại': { vi: 'Cắm trại', bn: 'ক্যাম্পিং' },
        'Làm vườn': { vi: 'Làm vườn', bn: 'বাগান করা' },
        'Câu cá': { vi: 'Câu cá', bn: 'মাছ ধরা' },
        'Chơi cờ': { vi: 'Chơi cờ', bn: 'দাবা খেলা' },
        'Học ngoại ngữ': { vi: 'Học ngoại ngữ', bn: 'ভাষা শেখা' },
        'Tình nguyện': { vi: 'Tình nguyện', bn: 'স্বেচ্ছাসেবামূলক কাজ' },
        'Chơi nhạc cụ': { vi: 'Chơi nhạc cụ', bn: 'বাদ্যযন্ত্র বাজানো' },
        'Sưu tầm tem': { vi: 'Sưu tầm tem', bn: 'ডাকটিকিট সংগ্রহ' },
        'Yoga': { vi: 'Yoga', bn: 'যোগব্যায়াম' },
        'Thiền': { vi: 'Thiền', bn: 'ধ্যান (মেডিটেশন)' },
        'Đạp xe': { vi: 'Đạp xe', bn: 'সাইকেল চালানো' },
        'Khiêu vũ': { vi: 'Khiêu vũ', bn: 'নাচ' },
        'Chăm sóc thú cưng': { vi: 'Chăm sóc thú cưng', bn: 'পোষা প্রাণীর যত্ন' },
        'Sửa chữa đồ đạc': { vi: 'Sửa chữa đồ đạc', bn: 'জিনিসপত্র মেরামত করা' },
        'Thủ công (handmade)': { vi: 'Thủ công (handmade)', bn: 'হস্তশিল্প' },
        'Thư pháp': { vi: 'Thư pháp', bn: 'ক্যালিগ্রাফি' },
        'Hát karaoke': { vi: 'Hát karaoke', bn: 'কারাওকে গাওয়া' },
        // Allergies
        'Không có dị ứng': { vi: 'Không có dị ứng', bn: 'কোনো অ্যালার্জি নেই' },
        'Phấn hoa': { vi: 'Phấn hoa', bn: 'পরাগরেণু (পোলেন)' },
        'Bụi nhà': { vi: 'Bụi nhà', bn: 'ধুলোবালি' },
        'Lông chó': { vi: 'Lông chó', bn: 'কুকুরের লোম' },
        'Lông mèo': { vi: 'Lông mèo', bn: 'বিড়ালের লোম' },
        'Nấm mốc': { vi: 'Nấm mốc', bn: 'ছত্রাক (মোল্ড)' },
        'Hải sản (chung)': { vi: 'Hải sản (chung)', bn: 'সামুদ্রিক খাবার (সব)' },
        'Tôm': { vi: 'Tôm', bn: 'চิงড়ি' },
        'Cua': { vi: 'Cua', bn: 'কাঁকড়া' },
        'Cá': { vi: 'Cá', bn: 'মাছ' },
        'Sò / Ốc': { vi: 'Sò / Ốc', bn: 'শামুক বা ঝিনুক' },
        'Mực': { vi: 'Mực', bn: 'স্কুইড' },
        'Đậu phộng (lạc)': { vi: 'Đậu phộng (lạc)', bn: 'চিনাবাদাম' },
        'Các loại hạt (óc chó, hạnh nhân...)': { vi: 'Các loại hạt (óc chó, hạnh nhân...)', bn: 'বাদাম জাতীয় খাবার' },
        'Sữa': { vi: 'Sữa', bn: 'দুধ' },
        'Trứng': { vi: 'Trứng', bn: 'ডিম' },
        'Lúa mì (Gluten)': { vi: 'Lúa mì (Gluten)', bn: 'গমের আটা (গ্লুটেন)' },
        'Đậu nành': { vi: 'Đậu nành', bn: 'সয়াবিন' },
        'Vừng': { vi: 'Vừng', bn: 'তিল' },
        'Thuốc Penicillin': { vi: 'Thuốc Penicillin', bn: 'পেনিসিলিন ওষুধ' },
        'Thuốc Aspirin': { vi: 'Thuốc Aspirin', bn: 'অ্যাসপিরিন ওষুধ' },
        'Thuốc kháng sinh khác': { vi: 'Thuốc kháng sinh khác', bn: 'অন্যান্য অ্যান্টিবায়োটিক' },
        'Thuốc gây tê': { vi: 'Thuốc gây tê', bn: 'অ্যানেস্থেশিয়া ওষুধ' },
        'Vết côn trùng cắn': { vi: 'Vết côn trùng cắn', bn: 'পোকামাকড়ের কামড়' },
        'Kim loại (Niken)': { vi: 'Kim loại (Niken)', bn: 'ধাতু (নিকেল)' },
        'Mủ cao su (Latex)': { vi: 'Mủ cao su (Latex)', bn: 'ল্যাটেক্স (রাবার)' },
        'Ánh nắng mặt trời': { vi: 'Ánh nắng mặt trời', bn: 'সূর্যের আলো' },
        'Thời tiết lạnh': { vi: 'Thời tiết lạnh', bn: 'ঠান্ডা আবহাওয়া' },
        'Hóa chất / Nước hoa': { vi: 'Hóa chất / Nước hoa', bn: 'রাসায়নিক বা পারফিউম' }
      }
    },
    card: {
      notUpdated: { vi: "Chưa cập nhật", bn: "হালনাগাদ করা হয়নি" },
      worker: { vi: "Lao động", bn: "কর্মী" },
      noExperience: { vi: "Chưa có kinh nghiệm", bn: "কোনো অভিজ্ঞতা নেই" },
      year: { vi: "năm", bn: "বছর" },
      month: { vi: "tháng", bn: "মাস" },
      english: { vi: "Tiếng Anh", bn: "ইংরেজি" },
      vietnamese: { vi: "Tiếng Việt", bn: "ভিয়েতনামী" },
      communication: { vi: "Giao tiếp", bn: "যোগাযোগ" },
      visaTypes: {
        unskilled: { vi: "Lao động phổ thông", bn: "সাধারণ কর্মী" },
        skilled: { vi: "Lao động kỹ thuật", bn: "দক্ষ কর্মী" },
        expert: { vi: "Kỹ sư, chuyên gia", bn: "ইঞ্জিনিয়ার ও শিক্ষিত কর্মী" }
      },
      salary: {
        current: { vi: "Lương hiện tại:", bn: "বর্তমান বেতন:" },
        desired: { vi: "Lương mong muốn:", bn: "আকাঙ্ক্ষিত বেতন:" },
        negotiable: { vi: "Thỏa thuận", bn: "আলোচনা সাপেক্ষে" },
        notFilled: { vi: "Chưa điền", bn: "পূরণ করা হয়নি" }
      },
      age: { vi: "tuổi", bn: "বয়স" },
      experience: { vi: "Kinh nghiệm:", bn: "অভিজ্ঞতা:" },
      foreignLanguage: { vi: "Ngoại ngữ:", bn: "বিদেশী ভাষা:" },
      media: {
        video: { vi: "video", bn: "ভিডিও" },
        videoItem: { vi: "Video", bn: "ভিডিও" },
        videoTitle: { vi: "Video", bn: "ভিডিও" },
        photo: { vi: "ảnh", bn: "ছবি" },
        photoItem: { vi: "Ảnh", bn: "ছবি" },
        photoTitle: { vi: "Ảnh toàn thân", bn: "পুরো শরীরের ছবি" },
        docs: { vi: "hồ sơ", bn: "নথি" },
        docItem: { vi: "Hồ sơ", bn: "নথি" },
        docTitle: { vi: "Hồ sơ", bn: "নথিপত্র" },
        clickToSeeDetails: { vi: "Bấm vào bất kỳ đâu để xem chi tiết đầy đủ", bn: "বিস্তারিত সব দেখতে সরাসরি প্রোফাইলে ক্লিক করুন" },
        clickToPlay: { vi: "Click vào video để xem ngay tại đây", bn: "এখানে ভিডিও দেখতে ক্লিক করুন" },
        viewAllInProfile: { vi: "Xem toàn bộ trong chi tiết hồ sơ", bn: "প্রোফাইল বিবরণে সব দেখুন" },
        seeAll: { vi: "Xem tất cả", bn: "সব দেখুন" },
        seeDetails: { vi: "Xem chi tiết", bn: "বিস্তারিত দেখুন" },
        noMedia: { vi: "Chưa có tài liệu", bn: "কোনো নথি নেই" }
      },
      mediaLabels: {
        'Ảnh chân dung': { vi: 'Ảnh chân dung', en: 'Portrait', bn: 'পোর্ট্রেট ফটো' },
        'Ảnh chân dung để dán vào form': { vi: 'Ảnh chân dung', en: 'Portrait', bn: 'আবেদনের জন্য পোর্ট্রেট ফটো' },
        'Ảnh toàn thân': { vi: 'Ảnh toàn thân', en: 'Full body', bn: 'পুরো শরীরের ছবি' },
        'Ảnh toàn thân trước': { vi: 'Ảnh toàn thân', en: 'Full body (front)', bn: 'পুরো শরীরের ছবি (সামনে)' },
        'Ảnh toàn thân phải': { vi: 'Ảnh toàn thân bên phải', en: 'Full body (right)', bn: 'পুরো শরীরের ছবি (ডান)' },
        'Ảnh toàn thân trái': { vi: 'Ảnh toàn thân bên trái', en: 'Full body (left)', bn: 'পুরো শরীরের ছবি (বাম)' },
        'Video giới thiệu bản thân': { vi: 'Video giới thiệu bản thân', en: 'Self-introduction', bn: 'নিজের পরিচয় diện ভিডিও' },
        'Giới thiệu bản thân': { vi: 'Giới thiệu bản thân', en: 'Self-introduction', bn: 'নিজের পরিচয়' },
        'introVideo': { vi: 'Giới thiệu bản thân', en: 'Self-introduction', bn: 'নিজের পরিচয়' },
        'Video tay nghề': { vi: 'Video tay nghề', en: 'Skill video', bn: 'পেশাদার দক্ষতা ভিডিও' },
        'Tay nghề 1': { vi: 'Tay nghề 1', en: 'Skill 1', bn: 'পেশাদার দক্ষতা ১' },
        'skillVideo1': { vi: 'Tay nghề 1', en: 'Skill 1', bn: 'পেশাদার দক্ষতা ১' },
        'Kỹ năng chuyên môn 1': { vi: 'Kỹ năng chuyên môn 1', en: 'Professional Skill 1', bn: 'পেশাদার দক্ষতা ১' },
        'Tay nghề 2': { vi: 'Tay nghề 2', en: 'Skill 2', bn: 'পেশাদার দক্ষতা ২' },
        'skillVideo2': { vi: 'Tay nghề 2', en: 'Skill 2', bn: 'পেশাদার দক্ষতা ২' },
        'Kỹ năng chuyên môn 2': { vi: 'Kỹ năng chuyên môn 2', en: 'Professional Skill 2', bn: 'পেশাদার দক্ষতা ২' },
        'Hộ chiếu các trang': { vi: 'Hộ chiếu', en: 'Passport', bn: 'পাসপোর্ট' },
        'Hộ chiếu (Mặt trước)': { vi: 'Hộ chiếu (Mặt trước)', en: 'Passport (Front)', bn: 'পাসপোর্ট (সামনে)' },
        'Hộ chiếu (Mặt sau)': { vi: 'Hộ chiếu (Mặt sau)', en: 'Passport (Back)', bn: 'পাসপোর্ট (পিছনে)' },
        'Thẻ ID quốc gia (NID)': { vi: 'Thẻ ID quốc gia', en: 'National ID card', bn: 'ন্যাশনাল আইডি কার্ড' },
        'Thẻ ID (Mặt trước)': { vi: 'Thẻ ID (Mặt trước)', en: 'National ID (Front)', bn: 'ন্যাশনাল আইডি (সামনে)' },
        'Thẻ ID (Mặt sau)': { vi: 'Thẻ ID (Mặt sau)', en: 'National ID (Back)', bn: 'ন্যাশনাল আইডি (পিছনে)' },
        'Lý lịch tư pháp': { vi: 'Lý lịch tư pháp', en: 'Police Clearance', bn: 'পুলিশ ক্লিয়ারেন্স' },
        'Giấy khám sức khỏe': { vi: 'Giấy khám sức khỏe', en: 'Medical report', bn: 'মেডিকেল রিপোর্ট' },
        'Bằng cấp/Chứng chỉ cao nhất': { vi: 'Bằng cấp/Chứng chỉ', en: 'Highest Degree', bn: 'শিক্ষাগত যোগ্যতা সনদ' },
        'Bằng Đại học/Cao đẳng': { vi: 'Bằng Đại học/Cao đẳng', en: 'Degree', bn: 'ডিগ্রি সনদ' },
        'Chứng chỉ nghề': { vi: 'Chứng chỉ nghề', en: 'Skill Certificate', bn: 'দক্ষতা সনদ' }
      },
      consultant: {
        missing: { vi: "Không có thông tin Đại lý", bn: "এজেন্সির তথ্য পাওয়া যায়নি" },
        chatWithConsultant: { vi: "Chat với Đại lý", bn: "এজেন্সির সাথে চ্যাট" }
      },
      buttons: {
        save: { vi: "Lưu", bn: "সংরক্ষণ" },
        edit: { vi: "Sửa", bn: "সম্পাদনা" },
        interview: { vi: "Mời phỏng vấn", bn: "ইন্টারভিউতে আমন্ত্রণ জানান" },
        interviewShort: { vi: "Mời phỏng vấn", bn: "ইন্টারভিউ ডাকুন" },
        contactAgency: { vi: "Liên hệ Đối tác", bn: "অংশীদারের সাথে যোগাযোগ" },
        contactMaster: { vi: "Liên hệ Tổng đại lý", bn: "কৌশলগত অংশীদার - মাস্টার এজেন্টের সাথে যোগাযোগ" }
      },
      registeredAt: { vi: "Đăng ký lúc:", bn: "নিবন্ধনের সময়:" },
      filterLabel: { vi: "Bộ lọc", bn: "ফিল্টার" },
      advancedFilterLabel: { vi: "Bộ lọc nâng cao", bn: "উন্নত ফিল্টার" }
    },
    results: {
      title: { vi: "Kết quả", bn: "ফলাফল" },
      count: { vi: "{count} Hồ sơ", bn: "{count} প্রোফাইল" },
      noResults: { vi: "Không tìm thấy ứng viên", bn: "কোনো প্রার্থী খুঁজে পাওয়া যায়নি" },
      noResultsDesc: { vi: "Hãy thử thay đổi bộ lọc hoặc từ khóa tìm kiếm để có nhiều kết quả hơn.", bn: "আরও ফলাফলের জন্য অনুগ্রহ করে ফিল্টার বা কীওয়ার্ড পরিবর্তন করার চেষ্টা করুন।" },
      resetFilters: { vi: "Xóa tất cả bộ lọc", bn: "সব ফিল্টার মুছুন" },
      pagination: {
        prev: { vi: "Trước", bn: "পূর্ববর্তী" },
        next: { vi: "Tiếp", bn: "পরবর্তী" }
      },
      unauthorized: {
        title: {
          vi: "Đăng nhập để xem ứng viên",
          bn: "প্রার্থী দেখতে লগইন করুন"
        },
        description: {
          vi: "Đăng nhập hoặc đăng ký tài khoản ngay để xem danh sách và thông tin chi tiết các ứng viên.",
          bn: "প্রার্থীদের তালিকা ও বিস্তারিত তথ্য দেখতে লগইন বা নিবন্ধন করুন।"
        },
        cta: {
          vi: "Đăng nhập / Đăng ký ngay",
          bn: "এখনই লগইন / নিবন্ধন করুন"
        }
      }
    },
    sort: {
      placeholder: { vi: "Sắp xếp theo", bn: "সাজানোর ধরণ" },
      options: {
        newest: { vi: "Mới nhất", bn: "সবচেয়ে নতুন" },
        salaryHigh: { vi: "Lương mong muốn: Cao > Thấp", bn: "কাঙ্ক্ষিত বেতন: উচ্চ > নিম্ন" },
        salaryLow: { vi: "Lương mong muốn: Thấp > Cao", bn: "কাঙ্ক্ষিত বেতন: নিম্ন > উচ্চ" },
        netSalaryHigh: { vi: "Thực lĩnh: Cao > Thấp", bn: "মোট বেতন: উচ্চ > নিম্ন" },
        netSalaryLow: { vi: "Thực lĩnh: Thấp > Cao", bn: "মোট বেতন: নিম্ন > উচ্চ" },
        priorityPhoto: { vi: "Ưu tiên có ảnh", bn: "ছবি অগ্রাধিকার" },
        priorityVideo: { vi: "Ưu tiên có video", bn: "ভিডিও অগ্রাধিকার" }
      }
    }
  }
};
